/**
 * 招募對話：如何開口 — the four rows a DISC letter is read for.
 *
 * A static lookup, not a product: the letter is already on file, and this says
 * what to do with it. Which is the same argument the DISC cell already makes in
 * 業務 view — what an adviser wants from a letter minutes before a meeting is
 * the advice behind it, not the letter again — except that the advice a career
 * conversation needs is not the advice a sales one does. A **D** wants to hear
 * how high it goes; an **S** needs to hear that nobody will rush them.
 *
 * Deliberately NOT PRO-gated, unlike the 智能 IDEA card it stands in for. There
 * is nothing to generate and nothing to spend — it is four sentences chosen by
 * a letter, and gating a lookup table would be charging for a table.
 *
 * Copy lives in the message files as `clientv2-recruit-disc-<letter>-<row>`, so
 * the playbook can be reworded by whoever owns the recruitment content without
 * touching any component. Source: the DISC → 點同佢講 table in
 * docs/specs/2026-08-31-clientv2-recruitment-mode-design.md §6.3.
 *
 * The rows are rendered by the shared DiscTips
 * (components/ClientEntry/SmartIdeaDialog), which Smart IDEA's business
 * playbook uses too; this module keeps the recruit-only 建議開場 lookup.
 * `ask` leads the rows: minutes before a meeting, the opener is the first thing
 * an adviser reaches for. Copy: `clientv2-recruit-disc-<letter>-ask`, three
 * questions separated by \n, rendered with white-space: pre-line.
 */

/**
 * 建議開場 — the one line the two facts on file agree on.
 *
 * The DISC letter says HOW to talk and 招募路線 says WHAT the person is deciding
 * about, and neither alone is an opening: 「講數字、講快」 to a fresh graduate who
 * has no numbers to compare is advice that cannot be followed. Crossing them
 * gives eight sentences, and both halves are answered in 快速資料, so this is a
 * lookup rather than anything to generate.
 *
 * Copy: `clientv2-recruit-approach-<letter>-<graduate|experienced>`. Null when
 * either half is missing — the card then says which one to answer instead of
 * printing a half-informed opener.
 */
export const recruitApproachId = (discLetter?: string | null, path?: string | null): string | null =>
  discLetter && (path === 'graduate' || path === 'experienced')
    ? `clientv2-recruit-approach-${discLetter}-${path}`
    : null;
